var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"form_date\">\n<i class=\"ico-calendar\"></i>\n<input type=\"text\" name=\"{{ ::vm.name }}\" ng-model=\"vm.date\" class=\"form_date_input\" ng-click=\"vm.openDatePicker($event)\" ng-focus=\"vm.openDatePicker($event)\" ng-required=\"vm.required\" ng-disabled=\"vm.disabled\" readonly=\"readonly\">\n</div>";
var id1="components/lbDateSelect/lbDateSelect.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbDateSelect/lbDateSelect.html
// module id = 1191
// module chunks = 1